import { Component, Host, h, Prop, Event, EventEmitter, State, Watch } from '@stencil/core';
import { LabelParser } from '../sew-ws-header/helpers/labels.helpers';
import { BasketLink } from '../sew-ws-header/types/basket-links.types';
import { BasketItem } from '../sew-ws-header/types/basket.types';
import { Labels } from '../sew-ws-header/types/labels.types';

@Component({
    tag: 'sew-ws-basket',
    styleUrl: 'sew-ws-basket.scss',
    shadow: false,
})
export class SewWsBasket {
    @Event() showBasket: EventEmitter;
    @Event() counter: EventEmitter;

    @Prop({ attribute: 'basketItems' }) basketItems: BasketItem[] = [];
    @Prop() links: BasketLink[] = [];
    @Prop() labels: Labels;

    @State() private labelParser: LabelParser;

    @Watch('labels')
    public watchLabels(): void {
        this.labelParser = new LabelParser(this.labels);
    }

    public componentWillLoad(): void {
        this.labelParser = new LabelParser(this.labels);
    }

    public componentWillRender(): void {
        this.basketItems && this.counter.emit(this.calcBasketItemsCount());
    }

    private calcBasketItemsCount(): string {
        if (!this.basketItems) {
            return '';
        }

        const count = this.basketItems.reduce(
            (sum, basketItem) => sum + (basketItem.unit !== 'ST' ? 1 : basketItem.quantity),
            0
        );

        return count > 99 ? '...' : count.toString();
    }

    render() {
        return (
            <Host>
                <div class="headline">
                    {this.basketItems && this.basketItems.length > 0
                        ? this.labelParser.getLabel('CMS_HEADER_BASKET_HEADLINE')
                        : this.labelParser.getLabel('CMS_HEADER_BASKET_HEADLINE_EMPTY')}
                </div>
                {this.basketItems && this.basketItems.length > 0 && (
                    <table>
                        {this.basketItems.slice(0, 5).map(item => (
                            <tr>
                                <td>{item.article}</td>
                                <td>{item.quantity}</td>
                            </tr>
                        ))}
                        {this.basketItems.length > 5 && (
                            <tr>
                                <td>...</td>
                                <td></td>
                            </tr>
                        )}
                    </table>
                )}

                <sew-ws-linklist-menu headline={this.labelParser.getLabel('CMS_HEADER_BASKET_ADD_PRODUCT')}>
                    {this.links &&
                        this.links.length &&
                        this.links
                            .filter(link => !link.isLocked && link.hasPermission)
                            .map(link => (
                                <sew-ws-link>
                                    <a href={link.link}>{link.linkText}</a>
                                </sew-ws-link>
                            ))}
                </sew-ws-linklist-menu>

                <sew-ws-button>
                    <button onClick={() => this.showBasket.emit()}>
                        {this.labelParser.getLabel('CMS_HEADER_BASKET_OPEN')}
                    </button>
                </sew-ws-button>
            </Host>
        );
    }
}
